import { ModelFactory } from '@shared/factories/model.factory';
import { PaymentOfJobType } from '@generated/graphql';
import { PaymentOfJob } from '@modules/payment/models/payment-of-job.model';

export class PaymentOfJobFactory extends ModelFactory<PaymentOfJobType, PaymentOfJob> {
  create (state: PaymentOfJobType): PaymentOfJob {
    return new PaymentOfJob(state);
  }
}

export const paymentOfJobFactory = new PaymentOfJobFactory();
